import { Directive, ElementRef, HostBinding, HostListener } from '@angular/core';

@Directive({
  selector: '[keyboardCloseIcon], img.close-icon, ion-icon.close-icon'
})
export class KeyboardCloseIconDirective {
   @HostBinding('attr.tabindex') tabIndex = 0;
  @HostBinding('attr.role') role = 'button';
  constructor(private readonly elRef: ElementRef<HTMLElement>) {}
  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.elRef.nativeElement.click();
  }
}